/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { useEffect, useRef, useState } from "react";
import { Autocomplete, TextField, Tooltip } from "@mui/material";

import { TreeSelect } from "primereact/treeselect";
import { useLocation, useNavigate } from "react-router-dom";

import TextInputField from "../../utils/text-input-field/TextInputField";
import AcceptTerms from "../../utils/accept-terms/AcceptTerms";
import "./CreateUser1.scss";
import ConfirmModal from "../../utils/modals/confirm-modal/ConfirmModal";
import InfoModal from "../../utils/modals/info-modal/InfoModal";
import Loader from "../Loader/Loader";
import UploadProfilePic from "../../utils/upload-profile-pic/UploadProfilePic";
import type { IErrorProps, Role } from "../../models";

import { getAccessToken } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import CountryCodeDTO from "../../models/apiModels/countryCodeDTO";
import { getOrganizationByTenantID } from "../../store/Organisation/organisation-actions";
import OrganizationDTO from "../../models/apiModels/OrganizationDTO";
import { getCountryCodes } from "../../store/Tenant/tenant-actions";
import OrganizationHDTOKey from "../../models/apiModels/OrganizationHDTOKey";
import {
  editUser,
  fetchLogoUser,
  getUserRolesbyOrg,
  uploadUserLogoDetails,
} from "../../store/User/user-actions";
import getOrganizationKeyByOrgId from "../../utils/methods/getOrganizationKeyByOrgId";
import GetOrgbyKey from "../../utils/methods/GetOrgbyKey";
import DefaultProfilePic from "../../images/DefaultProfilePic.png";
import TreeTableOrganizationData from "../../models/apiModels/TreeTableOrganizationData";
import OrganizationIdName from "../../models/apiModels/OrganizationIdName";
import getSelectedKeys from "../../utils/methods/getSelectedKey";
import BreadCrumbsComponent from "../SharedComponents/BreadCrumbs/BreadCrumbsComponent";
import Title from "../SharedComponents/Title/Title";
import {
  Card,
  CardContent,
  ControlError,
  Input,
  Label,
  Button,
  Chip,
  ChipRemove,
  Select,
  SelectOption,
} from "@forge/common";
import { Dropdown } from "../../utils/dropdown/dropdown";
import DropdownDTO from "../../models/componentModels/DropdownDTO";
import React from "react";
import { UUID } from "../../models/apiModels/Organization";
import addLogo from "../../images/addLogo.png";
import { serverErrorClose } from "../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../TenantUser/setErrorPopupsusingErrorCode";
import updateErrorList from "../../utils/methods/updateErrorList";
import ErrorHandlingComponent from "../SharedComponents/ErrorHandlingComponent";
import getOrganizationNameById from "../../utils/methods/getOrganizationNameById";
import sortByName from "../../utils/methods/sortByName";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import GetTokenValues from "../../utils/methods/GetTokenValues";
import { set } from "zod";
import { useTranslation } from '@scuf/localization';
import { localeKeyMap } from '../../localization/keys';

interface TreeNode {
  key: string;
  label: string;
  data: UUID;
  parentId: UUID;
  children: TreeNode[];
  version: number;
}
function EditUserPage1() {
  const [t] = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const [roleOptions, setRoleOptions] = useState<DropdownDTO[]>([]);

  const [countryCodeOptions, setcountryCodeOptions] = useState<
    Array<DropdownDTO>
  >([]);
  // Error lists
  // const [orgHierarchyData, setOrgHierarchyData] = useState<
  //   Array<OrganizationHierarchicalDTO>
  // >([]);

  /// Get values before Edit start
  const initialFirstName =
    location?.state?.userDetailsToEdit?.UserInfo?.firstName ?? "";
  const initialLastName =
    location?.state?.userDetailsToEdit?.UserInfo?.lastName ?? "";
  const initialEmailId =
    location?.state?.userDetailsToEdit?.UserInfo?.emailId ?? "";
  const initialPhonNumber =
    location?.state?.userDetailsToEdit?.UserInfo?.phoneNumber ?? "";
  const initialOrgArray: OrganizationIdName[] =
    location?.state?.userDetailsToEdit?.UserInfo?.organization ?? [];
  const initialOrganizations = initialOrgArray?.map((res) => {
    return res.id;
  });
  const hierarchicalOrganization = useSelector(
    (state: RootState) => state.organisation.treeTableOrganization
  );
  const userPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  /// Get Values before edit end
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);
  const [phoneNo, setPhoneNo] = useState(initialPhonNumber);
  const [emailId, setEmailId] = useState(initialEmailId);
  const [userProfilePic, setUserProfilePic] = useState<any>();
  const [existingProfilePic, setExistingProfilePic] = useState<string>();
  const [isRootNodeEnabled, setisRootNodeEnabled] = useState<boolean>(true);
  const [isFirstNameValid, setIsFirstNameValid] = useState<boolean>(true);
  const [islastNameValid, setIslastNameValid] = useState<boolean>(true);
  const [isFirstNameEmpty, setIsFirstNameEmpty] = useState<boolean>(false);
  const [isLastNameEmpty, setIsLastNameEmpty] = useState<boolean>(false);
  const [isEmailIdEmpty, setIsEmailIdEmpty] = useState<boolean>(false);
  const [isphoneEmpty, setisphoneEmpty] = useState<boolean>(false);
  const [isphoneValid, setisphoneValid] = useState<boolean>(true);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [isRoleIdEmpty, setIsRoleIdEmpty] = useState<boolean>(false);
  const [isOrganizationIdEmpty, setIsOrganizationIdEmpty] =
    useState<boolean>(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState<boolean>(false);
  const [isFormFilled, setIsFormFilled] = useState<boolean>(false);
  const [isCountryCodeEmpty, setCountryCodeEmpty] = useState<boolean>(false);
  const [helperTextCountryCode, sethelperTextCountryCode] = useState<string>(t(localeKeyMap.selectCode));
  const [postOrganizationData, setpostOrganizationData] = useState<UUID[]>([]);
  const [chipValues, setChipValues] = useState<
    { chipValue: string; tooltipValue: string; key: UUID }[]
  >([]);

  const [confirmModal, setConfirmModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [loadingRoles, setIsLoadingRoles] = useState<boolean>(false);

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const firstNameRegex = /^[a-zA-Z\s]*$/;
  const lastNameRegex = /^[a-zA-Z\s]*$/;
  const phoneNumberRegex = /^\d{7,14}$/;
  const [countryCodeValue, setCountryCode] = useState<CountryCodeDTO | null>(
    initialPhonNumber?.split(".")[0]
  );
  //CID 3263549
  const { UserInfo, CustomerId } = location?.state?.userDetailsToEdit || {
    UserInfo: null,
    CustomerId: null,
  };
  const [checkedOrgNodes, setCheckedOrgNodes] = useState<string[]>([]);
  const [selectedNodeKey, setSelectedNodeKey] = useState<any>([]);

  const [defaultRoles, setDefaultRoles] = useState<any[]>(
    UserInfo?.roles.map((role: any) => {
      return {
        label: role?.name,
        value: role?.roleId,
        ...role,
      };
    })
  );

  ///////////////Error Handling////////////////////////
  const toastErrors = useRef<IErrorProps[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  // on handleToastBarClose
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);

  useEffect(() => {
    const value = selectedNodeKey ?? [];

    const keys: string[] = Object?.keys(value);
    if (keys?.length > 0) {
      setIsOrganizationIdEmpty(false);
    } else {
      setIsOrganizationIdEmpty(true);
      // setRoleIds([]);
      // setIsRoleIdEmpty(true);
    }
  }, [selectedNodeKey]);

  //////////////Error Handling////////////////////////
  const defaultOrgKey = getOrganizationKeyByOrgId(
    UserInfo?.organization[0]?.id,
    hierarchicalOrganization
  );
  const [allRoleOption, setAllRoleOption] = useState<Array<Role>>([]); //API values

  const mainDefaultRole = UserInfo?.roles?.map((role: any) => {
    return {
      label: role?.name,
      value: role?.roleId,
      ...role,
    };
  }); //from Cell Values

  const [roleId, setRoleIds] = useState<string[]>(
    UserInfo?.roles?.map((role: any) => role?.roleId)
  );

  useEffect(() => {
    if (hierarchicalOrganization?.length === 0) return;
    const initialOrgKeys = initialOrganizations
      ?.map((x) => getOrganizationKeyByOrgId(x, hierarchicalOrganization))
      .map((x) => x?.key ?? "");

    let expandedKeys: any = {};
    const getExpandedKeysInFormatFromKeys: any = () => {
      //const convertedObject = {};

      const outputObject = Object.fromEntries(
        initialOrgKeys
          ?.filter((x) => x !== "")
          .map((element) => [element, true])
      );
      for (const [key, value] of Object.entries(outputObject)) {
        expandedKeys[key] = value;
      }
      return expandedKeys;
    };
    let expandedKeys1: any = getExpandedKeysInFormatFromKeys();
    if (expandedKeys1 !== undefined) {
      setSelectedNodeKey(expandedKeys1);
      selectedNodeKeyRef.current = Object.keys(expandedKeys1);
    }
  }, [hierarchicalOrganization]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchLogoUser({
        customerId: location?.state?.userDetailsToEdit?.CustomerId,
        userId: location?.state?.userDetailsToEdit?.UserInfo?.userId,
      })
    )
      .then((response: any) => {
        response.payload.data == 204
          ? setExistingProfilePic(addLogo)
          : setExistingProfilePic(response.payload.data);
        setIsLoading(false);
      })
      .catch((error: any) => {
        setExistingProfilePic("");
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const headers = {
    customerId: location?.state?.forgetenantID,
    accept: "application/json",
    Authorization: `Bearer ${getAccessToken()}`,
  };

  const treeTableOrganization: TreeTableOrganizationData[] = useSelector(
    (state: RootState) => state.organisation.treeTableOrganization
  );

  const hierarchicalOrganizationwKey: OrganizationHDTOKey[] = useSelector(
    (state: RootState) => state.organisation.hierarchicalOrganizationwKey
  );
  const organizationOrigionaldata: OrganizationDTO[] = useSelector(
    (state: RootState) => state.organisation.availableOrganization
  );

  // Get label names for hierarchy key
  // Label names for hierarchy key
  function getLabelNamesForHierarchyKey(
    tree: TreeNode[],
    key: string
  ): string[] {
    const labelNames: string[] = [];

    function findNodeByKey(currentNode: TreeNode | null, currentKey: string) {
      if (currentNode && currentNode.key === currentKey) {
        labelNames.push(currentNode.label);
        const parent = tree.find((node) => node.key === currentNode.parentId);
        if (parent) {
          findNodeByKey(parent, parent.key);
        }
      } else if (currentNode && currentNode.children) {
        currentNode.children.forEach((child) =>
          findNodeByKey(child, currentKey)
        );
      }
    }

    tree.forEach((node) => findNodeByKey(node, key));

    return labelNames.reverse();
  }

  function extractKeyValues(key: string): string[] {
    const keyParts = key?.split("-");
    return keyParts.map((_, index) => keyParts.slice(0, index + 1).join("-"));
  }

  /** Effect to set errro dialog or error toastbar state to open */
  // istanbul ignore next
  // Error handling useEffect

  //#region  Get country code value
  useEffect(() => {
    if (initialPhonNumber) {
      setPhoneNo(initialPhonNumber?.split(".")[1]);
    }
  }, [countryCodeOptions, initialPhonNumber]);

  ///#endregionENd    Get country code value

  useEffect(() => {
    //end for Assign Roles Logic
    const value = selectedNodeKey ?? [];

    const keys: string[] = Object?.keys(value);
    const values = keys?.map((x) => extractKeyValues(x));

    const labelNames = values?.map((y) =>
      y?.flatMap((x) => {
        let y = getLabelNamesForHierarchyKey(
          hierarchicalOrganizationwKey,
          x as unknown as string
        );
        if (y?.length > 0)
          return {
            labelName: y[0],
            key: x,
          };
      })
    );

    let newChipValues: {
      chipValue: string;
      tooltipValue: string;
      key: string;
    }[] = [];

    ///
    const newChipValuesFlatArray = labelNames?.flatMap((x) => {
      // Ensure x is neither null nor undefined before accessing its properties
      if (x) {
        //  CID 3263543;
        return [
          ...newChipValues,
          {
            chipValue: x[x.length - 1]?.labelName ?? "",
            tooltipValue: x.flatMap((y) => y?.labelName).join("-") ?? "",
            key: x[x.length - 1]?.key ?? "",
          },
        ];
      } else return [...newChipValues];
    });
    setChipValues([...newChipValuesFlatArray]);
    chipValueRef.current = newChipValuesFlatArray;
  }, [selectedNodeKey]);

  useEffect(() => {
    setIsLoading(true);
    const tenantInfoToBePassed = {
      tenantID: location?.state?.userDetailsToEdit?.CustomerId,
      userPermissions: userPermissions,
    };
    dispatch(getOrganizationByTenantID(tenantInfoToBePassed))
      .unwrap()
      .then(() => {})
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));

    setIsLoading(true);

    dispatch(getCountryCodes())
      .unwrap()
      .then((response) => {
        const sortedCountryCodes = sortByName(response || []);
        const countrycodeselected: DropdownDTO[] = sortedCountryCodes?.map(
          (value: any) => {
            return {
              value: value?.code,
              label: value?.name + " (" + value?.code + ")",
              // selected: value.code === countryCodeValue?.code,
              selected:
                value?.code === initialPhonNumber?.split(".")[0] ? true : false,
            };
          }
        );
        setcountryCodeOptions(countrycodeselected);

        return response;
      })
      .catch((error: any) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });

    setIsRoleIdEmpty(false);

    //to get all roles

    // setIsLoadingRoles(true);
    // dispatch(
    //   getUserRolesbyOrg({
    //     // orgId: initialOrganizations[0],
    //     tenantId: location?.state?.userDetailsToEdit?.CustomerId,
    //   })
    // )
    //   .unwrap()
    //   .then((response) => {
    //     setAllRoleOption(
    //       //#mockingdata
    //       response?.data?.map((obj: any) => {
    //         // mockdataRolesAPICopiedData?.map((obj: any) => {
    //         return {
    //           label: obj?.name ?? "",
    //           value: obj?.roleId ?? "",
    //           ...obj,
    //         };
    //       })
    //     );
    //   })
    //   .catch((error: any) => {
    //     setErrorListGlobal((prevState) =>
    //       updateErrorList(error, [...prevState])
    //     );
    //   })
    //   .finally(() => setIsLoadingRoles(false));

    //to get all roles end

    if (initialOrgArray?.length == 0) {
    } else {
      // setRoleIds([]);
      setIsLoadingRoles(true);
      dispatch(
        getUserRolesbyOrg({
          orgId: initialOrganizations[0],
          tenantId: location?.state?.userDetailsToEdit?.CustomerId,
        })
      )
        .unwrap()
        .then((response) => {
          const orgRoles = Array.isArray(response?.data) ? response?.data : [];
          const sortedRoles: Role[] = sortByName(orgRoles);

          const roleSelected: DropdownDTO[] = sortedRoles.map(
            (value: any) => {
              return {
                value: value?.roleId,
                label: value?.name,
                ...value
              };
            }
          );
          setRoleOptions(roleSelected);
        })
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoadingRoles(false));
      setCheckedOrgNodes([defaultOrgKey?.key]);
    }
  }, []);

  // Country code change handler from dropdown
  // istanbul ignore next

  // For tree table
  // istanbul ignore next
  // Custom node template
  const customNodeTemplate = (node: any) => {
    //CID 3263533
    const label = node.label ?? "";
    const orgData = GetOrgbyKey("0", treeTableOrganization);
    const rootLabel = orgData?.data?.name ?? "";
    const isLabel123 = label === rootLabel;
    const selectedNodesviaKey: string[] = Object.keys(selectedNodeKey ?? {});
    const containsZero = selectedNodesviaKey.includes("0");
    let backgroundColor = "";
    if (selectedNodesviaKey.length == 0) {
      backgroundColor = isLabel123 ? "#F7F7F7" : "inherit";
    } else if (containsZero) {
      backgroundColor = isLabel123 ? "#F7F7F7" : "#85848470";
    } else {
      backgroundColor = isLabel123 ? "#85848470" : "inherit";
    }

    return (
      //CID 3263548
      <div
        style={{
          backgroundColor: backgroundColor,
          height: "100%", // Simplified as the condition was redundant
          width: "100%", // Simplified as the condition was redundant
        }}
      >
        {label}
      </div>
    );
  };
  const backButtonHandler = () => {
    navigate(-1);
  };
  const cancelBtnHandler = () => {
    setConfirmModal(false);
    navigate(-1);
  };

  const countryCodeChangeHandler = (event: any) => {
    setCountryCode(event?.target?.value);
    if (event?.target?.value === null || event?.target?.value === "") {
      sethelperTextCountryCode(t(localeKeyMap.selectCode));
      setCountryCodeEmpty(true);
    } else {
      sethelperTextCountryCode("");
      setCountryCodeEmpty(false);
    }
  };
  const handleChangePhone = (event: any) => {
    if (event.target.value.length >= 14) {
      event.target.value = event.target.value.slice(0, 14);
    }
    setPhoneNo(event.target.value);

    if (event.target.value === "") {
      setisphoneEmpty(true);
      setisphoneValid(false);
    } else {
      setisphoneEmpty(false);
      setisphoneValid(true);
    }
    if (event && event.target && phoneNumberRegex?.test(event.target.value)) {
      setisphoneValid(true);
    } else {
      setisphoneValid(false);
    }

    setPhoneNo(event.target.value);
  };

  /**
   * Checks if the first name, last name, email and roled id entered
   * @returns boolean - returns fasle if any field is missing
   */
  let hasAllFieldsInput = () => {
    if (
      firstName &&
      lastName &&
      emailId &&
      roleId?.length &&
      countryCodeValue &&
      isphoneValid
    ) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * Checks if the first name, last, email id is valid or not
   * @returns boolean - returns false if any field is invalid.
   */
  const isInputValid = () => {
    if (isFirstNameValid && islastNameValid && isEmailValid && isphoneValid) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * To display helper text
   * Setting true  in state if any field is empty
   */
  const checkFieldEmpty = () => {
    !firstName && setIsFirstNameEmpty(true);
    !lastName && setIsLastNameEmpty(true);
    !emailId && setIsEmailIdEmpty(true);
    !phoneNo && setisphoneEmpty(true);
    !countryCodeValue && setCountryCodeEmpty(true);
    selectedNodeKey?.length === 0 && setIsOrganizationIdEmpty(true);
    roleId?.length === 0 && setIsRoleIdEmpty(true);

    const isAnyFieldEmpty =
      !firstName ||
      !lastName ||
      !emailId ||
      !roleId ||
      !phoneNo ||
      !countryCodeValue ||
      isOrganizationIdEmpty ||
      isRoleIdEmpty;
    // || (roleId as unknown as any)?.length === 0;
    return isAnyFieldEmpty;
    // !identityProvider && setisIdentityProviderEmpty(true);
  };

  const checkFieldEmptyForIP = () => {
    if (countryCodeValue === null || countryCodeValue.code === "") {
      sethelperTextCountryCode("Select Code");
      setCountryCodeEmpty(true);
      return true;
    }
    return false;
  };
  /**
   * @summery
   * input fields validation: empty field check
   * email basic validation
   * opens confirm modal if all mandatory fields entered
   */
  const createBtnHandler = () => {
    const isAnyFieldEmpty = checkFieldEmpty();
    const isIPFieldEmpty = checkFieldEmptyForIP();

    const hasAllFieldsValidInput =
      hasAllFieldsInput() && !isAnyFieldEmpty && !isIPFieldEmpty;

    if (hasAllFieldsValidInput && !isTermsAccepted) {
      setIsFormFilled(true);
      setIsTermsAccepted(false);
    }
    if (!emailRegex.test(emailId)) {
      setIsEmailValid(false);
    } else {
      setIsEmailValid(true);
    }

    // checking if all mandatory fields are filled and open confirm modal
    if (hasAllFieldsValidInput && isInputValid() && isTermsAccepted) {
      setConfirmModal(true);
    }
  };
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };

  /**
   *
   * Saving user in database on click confirm create btn
   */
  // istanbul ignore next
  // Takes all inputs and sends to API
  const confirmCreateHandler = () => {
    setConfirmModal(false);
    setOpenToastError(false);

    // Get Assign roles get roleIds added,removed
    // roleIds -> new roles
    // defaultRoles -> old roles
    let oldRoleIds = mainDefaultRole?.map((x: any) => x?.roleId);

    let roleIdAdded: string[] = roleId?.filter((x) => !oldRoleIds?.includes(x));
    let roleIdRemoved: string[] = oldRoleIds?.filter(
      (x: any) => !roleId?.includes(x)
    );
    //  Get Assign roles get roleIds added,removed
    // initialOrganizations -> old orgs

    // Get keys of all selected Nodes
    const value = selectedNodeKey ?? [];

    const keys: string[] = Object?.keys(value);

    // End get Keys of selected nodes
    let newOrgs = keys
      ?.map((x: any) => GetOrgbyKey(x, hierarchicalOrganization)?.data)
      ?.map((x) => x?.organizationId);
    let orgToBeAdded: string[] = newOrgs?.filter(
      (x) => !initialOrganizations?.includes(x)
    );
    let orgToBeRemoved: string[] = initialOrganizations?.filter(
      (x) => !newOrgs?.includes(x)
    );
    let organizations: { organizationId: UUID; type: "ADD" | "Remove" }[] = [];
    let roles: { roleId: string; type: "ADD" | "Remove" }[] = [];
    orgToBeAdded?.forEach((org) => {
      organizations?.push({ organizationId: org, type: "ADD" });
    });
    orgToBeRemoved?.forEach((org) => {
      organizations?.push({ organizationId: org, type: "Remove" });
    });
    roleIdAdded?.forEach((role) => {
      roles?.push({ roleId: role, type: "ADD" });
    });
    roleIdRemoved.forEach((role) => {
      roles?.push({ roleId: role, type: "Remove" });
    });
    const responseRoles = allRoleOption?.filter((x: { roleId: string }) =>
      roleId?.includes(x?.roleId)
    );

    const responseOrgs = keys
      ?.map((x: any) => GetOrgbyKey(x, hierarchicalOrganization)?.data)
      .map((x) => {
        return { id: x?.organizationId, name: x?.name };
      });
    let reqBody = {
      firstName: firstName,
      lastName: lastName,
      emailId: emailId,
      roles: roles,
      organizations: organizations,
      phoneNumber: countryCodeValue + "." + phoneNo,
      customerId: location?.state?.userDetailsToEdit?.UserInfo?.customerId,
      // Pass the customerId received during GetAll users call for this user
      tenantid: tokenInfo.tenant,
      // Pass the tenant Id from the token
      userId: UserInfo?.userId,
      responseRoles: responseRoles,
      responseOrgs: responseOrgs,
    };

    /**Creating new user in data base */
    setIsLoading(true);
    dispatch(editUser(reqBody))
      .unwrap()
      .then((response) => {
        setIsLoading(false);

        /** Upload User Profile Pic to database*/
        let userId = location?.state?.userDetailsToEdit?.UserInfo?.userId;

        /**Saving profile pic only if the user uploads  */
        if (userProfilePic) {
          setIsLoading(true);
          const postData = {
            userId: userId,
            logo: userProfilePic,
            customerId: location?.state?.userDetailsToEdit?.CustomerId,
          };
          dispatch(uploadUserLogoDetails(postData))
            .then((response) => {
              setIsLoading(false);

              setSuccessModal(true);
            })
            .catch((error) => {
              setIsLoading(false);

              setErrorListGlobal((prevState) =>
                updateErrorList(error, [...prevState])
              );
            })
            .finally(() => {
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
          setSuccessModal(true);
        }
        setSuccessModal(true);
      })
      .catch((error) => {
        setIsLoading(false);

        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  //for Selecting IP

  const getPhoneNoHelperText = () => {
    var helperTextPhone = t(localeKeyMap.phoneNumberHelperText);

    var helperTextCountryCode = t(localeKeyMap.selectCode);

    if (isCountryCodeEmpty && !isphoneValid) {
      return helperTextCountryCode + " & " + helperTextPhone;
    } else if (!isphoneValid) {
      return helperTextPhone;
    } else if (isCountryCodeEmpty) {
      return helperTextCountryCode;
    }
  };

  /**
   *
   * @param event
   * @param values selected values - list of objects
   * @param reason
   *
   * sets the selected options in the state
   */

  const assignRolesHandler = (event: any) => {
    if (
      event.target.value === "" ||
      event.target.value === null ||
      event.target.value === undefined
    ) {
      setDefaultRoles([]);
      setIsRoleIdEmpty(true);
      setRoleIds([]);
      return;
    }
    const selectedRoles = [event.target.value];

    setRoleIds(selectedRoles);
    if (selectedRoles) {
      // setChildRoleValue(values);
      setDefaultRoles(selectedRoles);
      setRoleIds(selectedRoles);
      // setIsRoleIdEmpty(false);
      selectedRoles.length > 0 && setIsRoleIdEmpty(false);
    }
  };

  const orgChipCloseHandler = (chip: any) => {
    //
    let newkeys = Object?.keys(selectedNodeKey);
    newkeys = newkeys?.filter((x) => x != chip.key);
    const newSelectedKeys = getSelectedKeys(newkeys);
    setSelectedNodeKey(newSelectedKeys);
    Object?.keys(newSelectedKeys)?.length === 0 && setDefaultRoles([]);
  };

  // For the parent node disabled
  const selectedNodeKeyRef = useRef<string[]>([]);
  const chipValueRef = useRef<any[]>([]);

  // Org file on click
  // istanbul ignore next
  const orgFiledOnClick = (e: any) => {
    setTimeout(() => {
      const parentNodeClass = document.querySelector("ul.p-tree-container");
      const getParentNodeClass = document.querySelector(
        "ul.p-tree-container > li > div.p-highlight"
      );
      const getParentUlClass = document.querySelector("ul.p-tree-container");
      getParentUlClass?.classList.add("custom_p_tree_container_edit_user");
      if (
        getParentNodeClass === null &&
        !selectedNodeKeyRef?.current?.includes("0") &&
        selectedNodeKeyRef?.current?.length !== 0 &&
        chipValueRef?.current?.length !== 0
      ) {
        parentNodeClass?.classList.add("parent_node_disabled");
      } else {
        parentNodeClass?.classList.remove("parent_node_disabled");
      }
    }, 200);
  };

  // Org file chnage
  // istanbul ignore next
  // Take the selected node key and set the selected node key
  const orgFiledOnChange = (e: any) => {
    if (e == null) {
      // Handle the case where e is null or undefined
      setChipValues([]);
      setSelectedNodeKey(undefined); // Adjust based on expected behavior
      selectedNodeKeyRef.current = [];
      setRoleIds([]);
      return;
    }
    const value = e.value ?? [];
    const resultinggg: string[] = Object.keys(value);
    const emptyObject = e.value ?? {};
    const isEmpty: boolean = Object.keys(emptyObject).length === 0;
    const has1Value: boolean = Object.keys(emptyObject).length === 1;
    let containsZero: boolean = false;

    if (resultinggg && Array.isArray(resultinggg)) {
      containsZero = resultinggg.includes("0");
    } else {
      console.error("resultinggg is not initialized properly.");
    }
    if (isEmpty) {
      setChipValues([]);
      chipValueRef.current = [];
      setSelectedNodeKey(e.value);
      setisRootNodeEnabled(true);
      setIsOrganizationIdEmpty(true);
      setDefaultRoles([]);
    } else if (has1Value && containsZero) {
      setChipValues([]);
      chipValueRef.current = [];
      setSelectedNodeKey(e.value);
      setisRootNodeEnabled(true);
    } else if (!containsZero) {
      // setChipValues([]);
      setSelectedNodeKey(e.value);
      setisRootNodeEnabled(false);
    } else {
    }
    selectedNodeKeyRef.current = Object?.keys(value);
    const result: any = Object?.entries(value)
      .filter(([key, val]) => val === true)
      .map(([key]) => key);

    // const resulttest = [];
    var data: any = e?.value ?? [];
    for (const key in data) {
      if (data[key]?.checked) {
        resultinggg?.push(key);
      }
    }

    setCheckedOrgNodes(resultinggg);

    function findLabelAndDataTest(
      node: OrganizationHDTOKey,
      key: string
    ): { label: string; data: UUID } | null {
      if (node?.key === key) {
        return { label: node?.label, data: node?.data };
      }

      for (const child of node?.children || []) {
        const result = findLabelAndDataTest(child, key);
        if (result) {
          return result;
        }
      }

      return null;
    }

    const resultDict: Record<string, { label: string; data: UUID }> = {};

    if (resultinggg) {
      resultinggg.forEach((key) => {
        if (hierarchicalOrganizationwKey) {
          hierarchicalOrganizationwKey.some((item) => {
            const result = findLabelAndDataTest(item, key);
            if (result) {
              resultDict[key] = result;
              return true;
            }
            return false;
          });
        }
      });
    }
    // Convert the resultDict to an array
    const resultArray = Object?.entries(resultDict)?.map(([key, value]) => ({
      key,
      ...value,
    }));
    // const sendDatatoPost = resultArray.map((obj) => {
    //   const postDataOrg = [];
    //   postDataOrg.push(obj.data).join(",");
    // });

    const dataArray: string[] = resultArray?.map((item) => {
      return item?.data?.toString();
    });
    setpostOrganizationData(dataArray);

    if (dataArray?.length == 0) {
    } else if (dataArray?.length == 1) {
      setRoleIds([]);
      setIsLoadingRoles(true);
      dispatch(
        getUserRolesbyOrg({
          orgId: dataArray[0],
          tenantId: location?.state?.userDetailsToEdit?.CustomerId,
        })
      )
        .unwrap()
        .then((response) => {
          const orgRoles = Array.isArray(response?.data) ? response?.data : [];
          const sortedRoles: Role[] = sortByName(orgRoles);

          const roleSelected: DropdownDTO[] = sortedRoles.map(
            (value: any) => {
              return {
                value: value?.roleId,
                label: value?.name,
                ...value
              };
            }
          );
          setRoleOptions(roleSelected);
        })
        .catch((error: any) => {
          setErrorListGlobal((prevState) =>
            updateErrorList(error, [...prevState])
          );
        })
        .finally(() => setIsLoadingRoles(false));
    } else {
      // dispatch(getUserRolesbyOrg({ orgId: dataArray[0] }));
    }

    setIsOrganizationIdEmpty(false);
    const parentNodeClass = document.querySelector("ul.p-tree-container");
    if (
      !selectedNodeKeyRef.current?.includes("0") &&
      !isEmpty &&
      selectedNodeKeyRef.current?.length !== 0 &&
      chipValueRef.current?.length !== 0
    ) {
      parentNodeClass?.classList.add("parent_node_disabled");
    } else {
      parentNodeClass?.classList.remove("parent_node_disabled");
    }
  };

  const [crumbs, setCrumbs] = useState([
    {
      id: "tenant",
      label: t(localeKeyMap.home),
    },
    {
      id: "tenantdetails",
      label: `${location?.state?.userDetailsToEdit?.CustomerId}`,
    },
    {
      id: "EditUser",
      label: t(localeKeyMap.editUserTitle),
    },
  ]);
  useEffect(() => {
    if (location?.pathname?.includes("organization")) {
      setCrumbs([
        {
          id: "Organisation",
          label: t(localeKeyMap.organization),
        },
        {
          id:
            location?.state?.userDetailsToEdit?.UserInfo
              ?.navigatedOrganization ?? "orgId",
          label:
            location?.state?.userDetailsToEdit?.UserInfo
              ?.navigatedOrganization ?? t(localeKeyMap.organization),
        },
        {
          id: "EditUser",
          label: t(localeKeyMap.editUserTitle),
        },
      ]);
    } else {
      setCrumbs([
        {
          id: "",
          label: t(localeKeyMap.home),
        },
        {
          id: "tenantdetails",
          label: `${location?.state?.userDetailsToEdit?.CustomerId}`,
        },
        {
          id: "CreateUser",
          label: t(localeKeyMap.editUserTitle),
        },
      ]);
    }
  }, [location]);
  return (
    <>
      <BreadCrumbsComponent
        crumbs={crumbs}
        backbutton={true}
        backButtonHandler={backButtonHandler}
      />
      <Title title={t(localeKeyMap.editUserTitle)} className="p-t15 p-b15" buttonRequired={false} />
      <Card className="create_user p-b15">
        <React.Fragment key=".0">
          <CardContent className="d-flex main_form_wrap p-20">
            {/* <div className="form_logo_wrap text-center"> */}
            <UploadProfilePic
              labelText={t(localeKeyMap.updatePhoto)}
              profilePic={
                !existingProfilePic
                  ? addLogo
                  : `data:image/png;base64,${existingProfilePic}`
              }
              onImageUpload={(image) => setUserProfilePic(image)}
            />

            <div className="form_box">
              <h4>{t(localeKeyMap.profileInformation)}</h4>
              <div className="form_row">
                <div className="form_col">
                  <TextInputField
                    fieldLabel={t(localeKeyMap.firstName)}
                    id="FirstName"
                    type="text"
                    disabled={true}
                    value={firstName}
                    required={true}
                    placeholder={t(localeKeyMap.enter)}
                    onChange={(value) => {
                      setFirstName(value);
                      setIsFirstNameEmpty(false);
                      firstNameRegex.test(value)
                        ? setIsFirstNameValid(true)
                        : setIsFirstNameValid(false);
                    }}
                    error={isFirstNameEmpty || !isFirstNameValid}
                    dataTestId="firstName"
                  />
                </div>
                <div className="form_col">
                  <TextInputField
                    value={lastName}
                    fieldLabel={t(localeKeyMap.lastName)}
                    id="LastName"
                    disabled={true}
                    type="text"
                    dataTestId="lastName"
                    required={true}
                    placeholder={t(localeKeyMap.enter)}
                    onChange={(value) => {
                      setLastName(value);
                      setIsLastNameEmpty(false);
                      lastNameRegex?.test(value)
                        ? setIslastNameValid(true)
                        : setIslastNameValid(false);
                    }}
                    error={isLastNameEmpty || !islastNameValid}
                  />
                </div>
                <div className="form_col">
                  <TextInputField
                    value={emailId}
                    fieldLabel={t(localeKeyMap.emailId)}
                    id="EmailID"
                    type="text"
                    disabled={true}
                    required={true}
                    // placeholder={t(localeKeyMap.enter)}
                    dataTestId="emailId"
                  />
                </div>
                <div className="form_col">
                  <Label required={true} className="text-input-label">
                    {t(localeKeyMap.phoneNumber)}
                  </Label>
                  <div className="phone_number_col">
                    <Dropdown
                      key={countryCodeOptions?.length}
                      onClick={function (): void {}}
                      items={countryCodeOptions}
                      defaultValue={countryCodeValue}
                      className="phoneNumber_dropdown"
                      onSelect={countryCodeChangeHandler}
                      useCheckIcon={true}
                      placeholder={t(localeKeyMap.selectCode)}
                      placeholderSearch={t(localeKeyMap.search)}
                      selectedLabel={t(localeKeyMap.selected)}
                      size="regular"
                      error={isCountryCodeEmpty}
                      variant="defaultSelect"
                      name="s"
                      selectLabel={["dew", "sjd"]}
                      showIcon={false}
                      enableSearch={true}
                      data-testid="countryCode"
                    />

                    <Input
                      id="phoneNo"
                      className="phone_number_textField"
                      value={phoneNo}
                      type="string"
                      placeholder={t(localeKeyMap.enterPhoneNumber)}
                      onChange={handleChangePhone}
                      error={isphoneEmpty || !isphoneValid}
                      data-testid="phoneNo"
                    />
                  </div>

                  {(isCountryCodeEmpty || isphoneEmpty || !isphoneValid) && (
                    <ControlError className="control-error">
                      {getPhoneNoHelperText()}
                    </ControlError>
                  )}
                </div>
                <div className="form_col">
                  <Label required={true} className="text-input-label">
                    {t(localeKeyMap.assignOrganization)}
                  </Label>
                  <TreeSelect
                    value={selectedNodeKey}
                    data-testid="orgTreeSelect"
                    className={
                      isOrganizationIdEmpty
                        ? "dropdown_tree error-border-tree"
                        : "dropdown_tree "
                    }
                    filter
                    required
                    nodeTemplate={customNodeTemplate}
                    onChange={(e) => orgFiledOnChange(e)}
                    onClick={(e) => orgFiledOnClick(e)}
                    options={hierarchicalOrganizationwKey}
                    metaKeySelection={false}
                    selectionMode="multiple"
                    placeholder={t(localeKeyMap.selectOrganizations)}
                    style={{
                      width: "100%",
                    }}
                  ></TreeSelect>

                  {isOrganizationIdEmpty && (
                    <ControlError className="control-error">
                      {t(localeKeyMap.pleaseAssignOrganization)}
                    </ControlError>
                  )}
                  <div className="form_col d-flex org-chip">
                    <div>
                      {chipValues.map(
                        (chip, index) =>
                          index < 2 && (
                            <Chip
                              className="mb-2"
                              onClick={function noRefCheck() {}}
                            >
                              {chip.chipValue}
                              <ChipRemove
                                onClick={() => orgChipCloseHandler(chip)}
                              >
                                {t(localeKeyMap.removeChip)}
                              </ChipRemove>
                            </Chip>
                          )
                      )}
                    </div>
                    {chipValues.length > 2 && (
                      <>
                        <Chip className="mb-2 dot-item">..</Chip>
                        <Tooltip
                          title={chipValues
                            .slice(2)
                            .map((chip, index) => chip.chipValue)
                            .join(", ")}
                          placement="top"
                          arrow={true}
                        >
                          <div>
                            <Chip className="mb-2">
                              {`+${(chipValues.length - 2).toString()}`}
                            </Chip>
                          </div>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>

                <div className="form_col">
                  <Label required>{t(localeKeyMap.assignRole)}</Label>
                  {chipValues.length === 0 ? (
                    <div>
                      <Select
                        defaultValue={roleId[0]}
                        id="assign-role-select-disabled"
                        key="assign-role-select-disabled"
                        placeholder={t(localeKeyMap.selectAnOption)}
                        disabled={isOrganizationIdEmpty}
                        className="select-role"
                        data-testid="SelectRole"
                      >
                        <SelectOption label="" value="" />
                      </Select>
                    </div>
                  ) : (
                    <Select
                      // defaultValue={roleId[0]}
                      id="assign-role-select"
                      key="assign-role-select-enabled"
                      onChange={(event: any) => {
                        assignRolesHandler(event);
                      }}
                      placeholder={t(localeKeyMap.selectAnOption)}
                      value={roleId[0]}
                      className="select-role"
                      data-testid="SelectRole"
                    >
                      {roleOptions.map((option: any) => {
                        return (
                          <SelectOption
                            key={option.value}
                            label={option.label}
                            value={option.value}
                          />
                        );
                      })}
                    </Select>
                  )}
                  {isRoleIdEmpty && (
                    <ControlError className="control-error">
                      {t(localeKeyMap.pleaseSelectRoles)}
                    </ControlError>
                  )}
                </div>
              </div>
              <AcceptTerms
                isFormFilled={isFormFilled}
                isTermsAccepted={isTermsAccepted}
                onTermsAccept={(event) => {
                  setIsTermsAccepted(event?.target.checked);
                }}
              />
            </div>
          </CardContent>
        </React.Fragment>
      </Card>
      <Card className="footer">
        <Button
          size="regular"
          variant="quiet-primary"
          className="cursor-pointer"
          onClick={() => cancelBtnHandler()}
          data-testid="cancelBtn"
        >
          {t(localeKeyMap.cancel)}
        </Button>

        <Button
          size="regular"
          variant="primary"
          className="cursor-pointer"
          onClick={createBtnHandler}
          data-testid="updateBtn"
        >
          {t(localeKeyMap.update)}
        </Button>
      </Card>
      {/* Footer end */}
      {isLoading || loadingRoles ? <Loader /> : null}
      <ConfirmModal
        dialogTitle={t(localeKeyMap.updateUser)}
        dialogContentText={t(localeKeyMap.updateUserDialogContent)}
        onConfirmClick={confirmCreateHandler}
        onCancelClick={() => setConfirmModal(false)}
        onCloseClick={() => setConfirmModal(false)}
        open={confirmModal}
        primaryBtnText={t(localeKeyMap.update)}
      />
      <InfoModal
        dialogTitle={t(localeKeyMap.updatingUser)}
        dialogContentText={t(localeKeyMap.updatingUserInfoDialogContent)}
        onOkClick={() => {
          setSuccessModal(false);
          
          // Get organization list for state
          const value = selectedNodeKey ?? {};
          const keys: string[] = Object?.keys(value);
          const organizationList = keys
            ?.map((x: any) => GetOrgbyKey(x, hierarchicalOrganization)?.data)
            .map((x) => ({ id: x?.organizationId, name: x?.name }));
          
          // Pass user update info for polling
          const userUpdateInfo = {
            userId: UserInfo?.userId,
            emailId: emailId,
            roles: roleId, // Array with single selected roleId
            organization: organizationList
          };
          
          // Navigate back to the previous page (tenant or organization user list)
          // React Router doesn't support state with navigate(-1), so we navigate to root first
          // and let the previous page's useEffect handle the state via session/local storage temporarily
          sessionStorage.setItem('userUpdateInfo', JSON.stringify(userUpdateInfo));
          navigate(-1);
        }}
        open={successModal}
      />
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={false}
        onCloseServerConflictError={function (): void {}}
      />
    </>
  );
}
export default EditUserPage1;
